<template>
  <div>
    <div style="padding: 5px">
      <div class="print-break-after">
        <div class="wg-row" style="font-size: 20px; justify-content: center">
          {{ $anm22.strLang(lang, "CUSTOMER", "CLIENTE") }}
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div class="wg-row">
          <!-- CLIENTE -->
          <div class="vertical-height-div" style="height: 3px"></div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Name", "Nome") }}
              </div>
              <input
                :disabled="mode === 'view'"
                ref="customer_firstName"
                v-if="project.customers.length > 0 || newContactMode"
                class="input-elem com-anm22-app-input-text"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                v-model="customer.firstName"
              />
              <div v-else class="input-elem">
                <wg-search
                  :disabled="mode === 'view'"
                  :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                  :url="'paglierani/searchContacts'"
                  :clickFn="selectContact"
                  :canAdd="true"
                  :addFn="(val) => setNewContactMode('firstName', val)"
                  :attachedData="{ projectId: project.idWorldProject }"
                  :debounceTime="2000"
                ></wg-search>
              </div>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Last name", "Cognome") }}
              </div>
              <input
                ref="customer_lastName"
                v-if="project.customers.length > 0 || newContactMode"
                class="input-elem com-anm22-app-input-text"
                type="text"
                :disabled="mode === 'view'"
                :placeholder="$anm22.strLang(lang, 'Last name', 'Cognome')"
                v-model="customer.lastName"
              />
              <div v-else class="input-elem">
                <wg-search
                  :placeholder="$anm22.strLang(lang, 'Last name', 'Cognome')"
                  :url="'paglierani/searchContacts'"
                  :clickFn="selectContact"
                  :canAdd="true"
                  :disabled="mode === 'view'"
                  :addFn="(val) => setNewContactMode('firstName', val)"
                  :attachedData="{ projectId: project.idWorldProject }"
                  :debounceTime="2000"
                ></wg-search>
              </div>
            </div>
          </div>
        </div>
        <!-- CONTRATTO -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Contratto", "Contratto") }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.contract"
                class="input-elem com-anm22-app-input-text"
                type="text"
              />
            </div>
          </div>
          <!--DATA -->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Date", "Data commessa") }}
              </div>
              <input
                :disabled="mode === 'view'"
                class="input-elem com-anm22-app-input-date"
                type="date"
                v-model="date"
                :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
              />
            </div>
          </div>
        </div>
        <!-- COMMESSA -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Commessa", "Commessa") }}
              </div>
              <input
                v-model="details.order"
                :disabled="mode === 'view'"
                class="input-elem com-anm22-app-input-text"
                type="text"
              />
            </div>
          </div>
          <!-- CONSEGNA PREVISTA CONTRATTUALMENTE -->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Scheduled Delivery",
                    "Consegna prevista contrattualmente"
                  )
                }}
              </div>
              <input
                class="input-elem com-anm22-app-input-date"
                type="date"
                :disabled="mode === 'view'"
                v-model="expectedDelivery"
                :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
              />
            </div>
          </div>
        </div>
        <!-- CONSEGNA PREVISTA REALE -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Real Delivery",
                    "Consegna prevista reale"
                  )
                }}
              </div>
              <input
                class="input-elem com-anm22-app-input-date"
                type="date"
                :disabled="mode === 'view'"
                v-model="realDelivery"
                :placeholder="$anm22.strLang(lang, 'dd/mm/yyyy', 'gg/mm/aaaa')"
              />
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Payment variations",
                    "Variazioni di pagamento"
                  )
                }}
              </div>
              <textarea
                :disabled="mode === 'view'"
                :class="[
                  'input-elem com-anm22-app-textarea',
                  mode === 'view' ? 'stamp' : '',
                ]"
                style="height: 100px; width: 100%; max-width: unset"
                v-model="details.paymentVariations"
              ></textarea>
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Discount", "Sconti") }}
              </div>
              <div class="com-anm22-horizontal-div" style="width: 4px"></div>
              <textarea
                :disabled="mode === 'view'"
                :class="[
                  'input-elem com-anm22-app-textarea',
                  mode === 'view' ? 'stamp' : '',
                ]"
                style="height: 100px; width: 100%; max-width: unset"
                v-model="details.discount"
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="print-break-after"></div> -->
    <!-- <div class="com-anm22-app-horizontal-line-light"></div> -->
    <div style="padding: 5px">
      <div class="print-break-after">
        <div class="wg-row" style="font-size: 20px; justify-content: center">
          {{
            $anm22.strLang(lang, "UFFICIO COMMERCIALE", "UFFICIO COMMERCIALE")
          }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <!-- PREZZO CONTRATTUALE -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Prezzo contrattuale",
                    "Prezzo contrattuale"
                  )
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.contractPrice"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.contractPrice
                    ? Number(details.contractPrice).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Various", "Varie") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.others"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.others ? Number(details.others).toLocaleString() : ''
                "
              />
            </div>
          </div>
        </div>

        <div class="wg-row">
          <!-- VARIE -->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Reso", "Reso") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.surplus"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.surplus
                    ? Number(details.surplus).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Montaggio + Collaudo",
                    "Montaggio + Collaudo"
                  )
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.assemblyAndTesting"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.assemblyAndTesting
                    ? Number(details.assemblyAndTesting).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
        </div>
        <!-- IMBALLO -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Imballo", "Imballo") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.packaging"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.packaging
                    ? Number(details.packaging).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Viaggio", "Viaggio") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.travel"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.travel ? Number(details.travel).toLocaleString() : ''
                "
              />
            </div>
          </div>
          <!-- VITTO E ALLOGGIO -->
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "Vitto + Alloggio", "Vitto + Alloggio")
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                class="input-elem com-anm22-app-input-text"
                type="number"
                v-model="details.accommodation"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.accommodation
                    ? Number(details.accommodation).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
          <!-- NETTO CONTRATTUALE -->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Netto macchine contrattuale",
                    "Netto macchine contrattuale"
                  )
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                disabled
                class="input-elem com-anm22-app-input-text"
                type="number"
                :value="netContractual"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="Number(netContractual).toLocaleString()"
              />
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height: 27px"></div>
        <!-- GIORNI UOMO PREVISTI -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Giorni uomo previsti",
                    "Giorni uomo previsti"
                  )
                }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.expectedManDays"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
            </div>
          </div>
          <!-- N VIAGGI PREVISTI-->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(lang, "N viaggi previsti", "N viaggi previsti")
                }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.expectedTravels"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "N tecnici previsti",
                    "N tecnici previsti"
                  )
                }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.expectedTech"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Tariffa quotata (Uomo/Giorno)",
                    "Tariffa quotata (Uomo/Giorno)"
                  )
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.listedRate"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.listedRate
                    ? Number(details.listedRate).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "", "Quotazione riferimento") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.quotationRef"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.quotationRef
                    ? Number(details.quotationRef).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{
                  $anm22.strLang(
                    lang,
                    "Importo lordo quote",
                    "Importo lordo quote"
                  )
                }}
              </div>
              <input
                v-if="mode == 'edit'"
                :disabled="mode === 'view'"
                v-model="details.quoteAmount"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.quoteAmount
                    ? Number(details.quoteAmount).toLocaleString()
                    : ''
                "
              />
            </div>
          </div>
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{
                $anm22.strLang(
                  lang,
                  "",
                  "Sconto finale sul valore macchine (%)"
                )
              }}
            </div>
            <input
              :disabled="mode === 'view'"
              v-model="details.finalDiscount"
              class="input-elem com-anm22-app-input-text"
              type="number"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="print-break-after">
      <div style="padding: 5px">
        <div class="wg-row" style="font-size: 20px; justify-content: center">
          {{ $anm22.strLang(lang, "COMMISSION", "CALCOLO PROVVIGIONE") }}
        </div>
        <div class="vertical-height-div" style="height: 20px"></div>
        <div class="wg-row">
          <!--<div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Agent", "Agente") }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.agentName"
                class="input-elem com-anm22-app-input-text"
                type="text"
              />
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Subagent", "Subagente") }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.subAgentName"
                class="input-elem com-anm22-app-input-text"
                type="text"
              />
            </div>
          </div>-->
          <div class="wg-col wg-xs-12 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Percentual (%)", "Percentuale (%)") }}
              </div>
              <input
                :disabled="mode === 'view'"
                v-model="details.agentRate"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">
              {{ $anm22.strLang(lang, "Importo", "Importo") }}
            </div>
            <input
              disabled
              v-if="mode == 'edit'"
              v-model="agentImport"
              class="input-elem com-anm22-app-input-text"
              type="number"
            />
            <input
              disabled
              v-else
              class="input-elem com-anm22-app-input-text align"
              type="text"
              :value="agentImport ? Number(agentImport).toLocaleString() : ''"
            />
          </div>
        </div>
      </div>
      <div style="padding: 5px">
        <div class="wg-row" style="font-size: 17px; justify-content: center">
          {{ $anm22.strLang(lang, "Totali per sezione", "Totali per sezione") }}
        </div>
        <div class="vertical-height-div" style="height: 5px"></div>
        <div class="wg-row">
          <div style="text-align: center" class="wg-col wg-xs-6 wg-sm-6">
            {{ $anm22.strLang(lang, "Gross", "Lordi") }}
          </div>
          <div style="text-align: center" class="wg-col wg-xs-6 wg-sm-6">
            {{ $anm22.strLang(lang, "Netti", "Netti") }}
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione A ", "Sezione A") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.grossA"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.grossA ? Number(details.grossA).toLocaleString() : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione A", "Sezione A") }}
              </div>
              <input
                disabled
                v-if="mode == 'edit'"
                :value="netSection(details.grossA)"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  isNaN(netSection(details.grossA))
                    ? ''
                    : Number(netSection(details.grossA)).toLocaleString()
                "
              />
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione B ", "Sezione B") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.grossB"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.grossB ? Number(details.grossB).toLocaleString() : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione B", "Sezione B") }}
              </div>
              <input
                disabled
                v-if="mode == 'edit'"
                :value="netSection(details.grossB)"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  isNaN(netSection(details.grossB))
                    ? ''
                    : Number(netSection(details.grossB)).toLocaleString()
                "
              />
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione C", "Sezione C") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.grossC"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.grossC ? Number(details.grossC).toLocaleString() : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione C", "Sezione C") }}
              </div>
              <input
                disabled
                v-if="mode == 'edit'"
                :value="netSection(details.grossC)"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  isNaN(netSection(details.grossC))
                    ? ''
                    : Number(netSection(details.grossC)).toLocaleString()
                "
              />
            </div>
          </div>
        </div>
        <div class="wg-row">
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione D", "Sezione D") }}
              </div>
              <input
                v-if="mode == 'edit'"
                v-model="details.grossD"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  details.grossD ? Number(details.grossD).toLocaleString() : ''
                "
              />
            </div>
          </div>
          <div class="wg-col wg-xs-6 wg-sm-6">
            <div class="wg-row input-row">
              <div class="com-anm22-app-text-m">
                {{ $anm22.strLang(lang, "Sezione D", "Sezione D") }}
              </div>
              <input
                disabled
                v-if="mode == 'edit'"
                :value="netSection(details.grossD)"
                :style="{ width: windowWidth < 768 ? '90%' : '' }"
                class="input-elem com-anm22-app-input-text"
                type="number"
              />
              <input
                disabled
                v-else
                class="input-elem com-anm22-app-input-text align"
                type="text"
                :value="
                  isNaN(netSection(details.grossD))
                    ? ''
                    : Number(netSection(details.grossD)).toLocaleString()
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="print-break-after"></div> -->
    <!-- <div class="com-anm22-app-horizontal-line-light"></div> -->
    <div class="wg-row" style="padding: 5px">
      <div class="wg-row" style="font-size: 20px; justify-content: center">
        {{
          $anm22.strLang(
            lang,
            "UFFICIO GESTIONE ORDINI",
            "UFFICIO GESTIONE ORDINI"
          )
        }}
      </div>
      <div
        class="com-anm22-app-text-m"
        style="margin-top: 10px; text-align: center"
      >
        {{
          $anm22.strLang(lang, "Aggiunte contrattuali", "Aggiunte contrattuali")
        }}
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div style="width: 50%; margin-left: 6%" class="wg-row">
        <div class="com-anm22-app-text-m">
          {{ $anm22.strLang(lang, "Add", "Aggiungi") }}
        </div>
        <img
          :title="$anm22.strLang(lang, 'Add', 'Aggiungi')"
          style="margin-top: -4px; cursor: pointer"
          @click="addContractRow()"
          :src="$anm22.icons.getWorldIcon('add')"
        />
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div v-if="contrs.length > 0" class="wg-row" style="justify-content:space-around;">
        <div class="wg-col wg-xs-3">
          {{ $anm22.strLang(lang, "Description", "Descrizione") }}
        </div>
        <div class="wg-col wg-xs-3">
          {{ $anm22.strLang(lang, "Import", "Importo") }}
        </div>
      </div>
      <div
        class="wg-row input-row"
        style="padding: 5px"
        v-for="(contract, index) in contrs"
        :key="'contractual-add' + index"
      >
        <div class="wg-col wg-xs-1">
          <div class="com-anm22-app-text-m">{{ index + 1 }}</div>
        </div>
        <div class="wg-col wg-xs-6">
          <input
            :disabled="mode === 'view'"
            class="input-elem com-anm22-app-input-text"
            type="text"
            :style="{ width: windowWidth < 768 ? '90%' : '' }"
            v-model="contract.description"
          />
        </div>
        <div class="com-anm22-horizontal-div" style="width: 2px"></div>
        <div class="wg-col wg-xs-6">
          <input
            v-if="mode == 'edit'"
            class="input-elem com-anm22-app-input-text"
            type="number"
            :style="{ width: windowWidth < 768 ? '90%' : '' }"
            v-model="contract.import"
          />
          <input
            v-else
            disabled
            class="input-elem com-anm22-app-input-text align"
            type="text"
            :value="
              contract.import ? Number(contract.import).toLocaleString() : ''
            "
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height: 20px"></div>
      <div class="wg-row input-row">
        <div class="wg-col wg-xs-6">
          <div class="com-anm22-app-text-m">
            {{
              $anm22.strLang(
                lang,
                "Netto macchine con aggiunte contrattuali",
                "Netto macchine con aggiunte contrattuali"
              )
            }}
          </div>
          <div class="vertical-height-div" style="height: 5px"></div>
          <input
            v-if="mode == 'edit'"
            disabled
            class="input-elem com-anm22-app-input-text"
            type="number"
            v-model="netto"
          />
          <input
            disabled
            v-else
            class="input-elem com-anm22-app-input-text align"
            type="text"
            :value="Number(netto).toLocaleString()"
          />
        </div>
      </div>
    </div>
    <!-- <div class="com-anm22-app-horizontal-line-light"></div> -->
    <div class="wg-row" style="padding: 5px">
      <div class="wg-row" style="font-size: 20px; justify-content: center">
        {{
          $anm22.strLang(
            lang,
            "UFFICIO GESTIONE TECNICI",
            "UFFICIO GESTIONE TECNICI"
          )
        }}
      </div>
      <div class="vertical-height-div" style="height: 10px"></div>
      <div style="text-align: center" class="wg-row">
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "Giorni uomo tot", "Giorni uomo tot")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.manDaysTot"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "In garanzia", "In garanzia")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.manDaysInWarranty"
            class="input-elem com-anm22-app-input-text"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "Effettivi", "Effettivi")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            v-model="details.realManDays"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
      </div>
      <div style="text-align: center" class="wg-row">
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "N viaggi totali", "N viaggi totali")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.totalTravels"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "In garanzia", "In garanzia")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.travelsInWarranty"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "Effettivi", "Effettivi")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            v-model="details.realTravels"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
      </div>
      <div style="text-align: center" class="wg-row">
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "N giorni", "N giorni")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.totalDays"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "In garanzia", "In garanzia")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.daysInWarranty"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
        <div class="wg-col wg-xs-4">
          <span style="margin-left: -10%">{{
            $anm22.strLang(lang, "Effettivi", "Effettivi")
          }}</span>
          <div class="vertical-height-div" style="height: 3px"></div>
          <input
            :disabled="mode === 'view'"
            v-model="details.realDays"
            :style="{ width: windowWidth < 640 ? '80%' : '' }"
            class="input-elem com-anm22-app-input-text"
            type="number"
          />
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height: 10px"></div>
    <div v-if="mode == 'edit'" class="wg-row" style="padding: 5px">
      <input
        type="button"
        :value="$anm22.strLang(lang, 'Save', 'Salva')"
        @click="saveContact"
      />
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <paglierani-widget-history
        :projectId="project.idWorldProject"></paglierani-widget-history>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PaglieraniWidgetHistory from "./PaglieraniWidgetHistory.vue"

export default {
  components: {
    PaglieraniWidgetHistory
  },
  props: {
    projectId: [Number, String],
    docs: Object,
    mode: {
      type: String,
      default: "edit",
    },
  },
  data() {
    return {
      newContactMode: false,
      customer: {},
      details: {
        contracts: [],
      },
      contrs: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
      windowWidth: (state) => state.windowWidth,
    }),
    agentImport() {
      let netto = this.netContractual;
      let percentual = this.details.agentRate;
      let result = (netto * percentual) / 100;
      return Math.round(result * 100) / 100;
    },
    netContractual() {
      let newContractPrice = 0;
      let travel = 0;
      let surplus = 0;
      let assAndTest = 0;
      let packaging = 0;
      let accommodation = 0;
      let various = 0;
      if (this.details.contractPrice) {
        newContractPrice = Number(this.details.contractPrice);
      }
      if (this.details.travel) {
        travel = Number(this.details.travel);
      }
      if (this.details.accommodation) {
        accommodation = Number(this.details.accommodation);
      }
      if (this.details.surplus) {
        surplus = Number(this.details.surplus);
      }
      if (this.details.assemblyAndTesting) {
        assAndTest = Number(this.details.assemblyAndTesting);
      }
      if (this.details.others) {
        various = Number(this.details.others);
      }
      if (this.details.packaging) {
        packaging = Number(this.details.packaging);
      }
      newContractPrice =
        newContractPrice +
        travel +
        various +
        accommodation +
        surplus +
        assAndTest +
        packaging;

      return Math.round(newContractPrice * 100) / 100;
    },
    netto() {
      let total = Number(this.netContractual);
      let contracts = this.contrs;
      contracts.forEach((contract) => {
        total += Number(contract.import);
      });
      return Math.round(total * 100) / 100;
    },
    date: {
      get() {
        if (this.details.date) {
          return this.$moment
            .unix(this.details.date)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          let tsNow = this.$moment().unix();
          this.details.date = tsNow;
          return this.$moment.unix(tsNow).utc().format("YYYY-MM-DD");
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.details.date = "";
        } else if (ts) {
          this.details.date = ts;
        }
      }, 2000),
    },
    expectedDelivery: {
      get() {
        if (this.details.expectedDelivery) {
          return this.$moment
            .unix(this.details.expectedDelivery)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.details.expectedDelivery = "";
        } else if (ts) {
          this.details.expectedDelivery = ts;
        }
      }, 2000),
    },
    realDelivery: {
      get() {
        if (this.details.realDelivery) {
          return this.$moment
            .unix(this.details.realDelivery)
            .utc()
            .format("YYYY-MM-DD");
        } else {
          return;
        }
      },
      set: _.debounce(function (newDate) {
        let ts = this.$moment.utc(newDate).unix();
        if (isNaN(ts)) {
          this.details.realDelivery = "";
        } else if (ts) {
          this.details.realDelivery = ts;
        }
      }, 2000),
    },
    project() {
      return this.$store.getters["projects/get"]([this.projectId]);
    },
  },
  methods: {
    saveForm() {
      const docs = { ...this.docs };
      docs.details = this.details;
      this.$emit("canUpdateProject", true);
      this.$emit("save", docs);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
    netSection(gross) {
      gross = Number(gross);
      let percent = this.details.finalDiscount;
      let result = 0;
      result = gross - (gross * Number(percent)) / 100;
      result = Number(result);
      return Math.round(result * 100) / 100;
    },
    addContractRow() {
      this.contrs.push({
        description: "",
        import: 0,
      });
    },

    saveContact() {
      if (this.project.customers.length > 0) {
        this.$http
          .post("paglierani/editContact", {
            projectId: this.project.idWorldProject,
            contact: this.customer,
          })
          .then((response) => {
            this.customer = response.data.contact;
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact],
              }),
            ]);
          })
          .then((result) => {
            this.saveForm();
          })
          .catch((error) => console.log(error));
      } else {
        this.$http
          .post("paglierani/newContact", {
            projectId: this.project.idWorldProject,
            contact: this.customer,
          })
          .then((response) => {
            /* Aggiungo il nuovo cliente al progetto */
            let project = { ...this.project };
            project.customers.push(response.data.contact.idContactsContact);
            this.customer = response.data.contact;
            /* Aggiorno il db locale */
            return Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [response.data.contact],
              }),
            ]);
          })
          .then((result) => {
            this.saveForm();
          })
          .catch((error) => {
            // Offline
          });
      }
    },
    setNewContactMode(field, val) {
      this.customer[field] = val;
      this.newContactMode = true;
      this.$nextTick(() => {
        this.$refs["customer_" + field].focus();
      });
    },
    selectContact(id) {
      this.$http
        .post("paglierani/selectContact", {
          projectId: this.project.idWorldProject,
          idContact: id,
        })
        .then((response) => {
          /* Aggiungo il nuovo cliente al progetto */
          let project = { ...this.project };
          project.customers.push(response.data.contact.idContactsContact);
          this.customer = response.data.contact;
          /* Aggiorno il db locale */
          return Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact],
            }),
          ]);
        })
        .then(() => {
          this.saveForm();
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    if (this.project.customers.length > 0) {
      this.customer = {
        ...this.$store.getters["contacts/get"](this.project.customers[0]),
      };
    }
    this.details = { ...this.docs.details };
    if (!this.details.contracts) {
      this.details.contracts = [];
    }
    this.contrs = this.details.contracts;
  },
};
</script>

<style lang="scss" scoped>
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
  min-height: 36px;
}
input[type="number"] {
  text-align: right;
}

.input-elem {
  width: 200px;
}
.stamp {
  height: 260px !important;
}
@media print {
  .print-break-after {
    break-after: page;
  }
  .align {
    text-align: right !important;
  }
  input[type="text"],
  input[type="date"],
  input[type="number"] {
    height: 36px !important;
  }
}
</style>
